import {Deal, DealType} from "@irati/types"

export const shouldDisplayDealAvatar = (deal: Deal): boolean => deal.type === DealType.Company || !!deal.thumbnailImage
